/*
  assets/shoppable-video.js
  Shared script for:
    - sections/shoppable-videos.liquid          (homepage carousel)
    - sections/shoppable-video-floating.liquid  (product-page floating video)
*/
(function () {
  'use strict';
  if (window.ShoppableVideo) return;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var DESIGN = !!(window.Shopify && window.Shopify.designMode);
  var REDUCED = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var FALLBACK_TTL = 5 * 60 * 1000;

  function svg(inner) {
    return (
      '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" ' +
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + inner + '</svg>'
    );
  }

  var ICON = {
    close: svg('<path d="M6 6l12 12M18 6L6 18"/>'),
    prev: svg('<path d="M15 5l-7 7 7 7"/>'),
    next: svg('<path d="M9 5l7 7-7 7"/>'),
    soundOn: svg('<path d="M4 9v6h4l5 4V5L8 9H4z"/><path d="M16 9a4 4 0 010 6M18.5 6.5a8 8 0 010 11"/>'),
    soundOff: svg('<path d="M4 9v6h4l5 4V5L8 9H4z"/><path d="M17 9l5 6M22 9l-5 6"/>'),
    share: svg('<circle cx="18" cy="5" r="2.5"/><circle cx="6" cy="12" r="2.5"/><circle cx="18" cy="19" r="2.5"/><path d="M8.2 10.8l7.6-4.5M8.2 13.2l7.6 4.5"/>'),
    external: svg('<path d="M14 4h6v6M20 4l-9 9M18 14v5a1 1 0 01-1 1H5a1 1 0 01-1-1V7a1 1 0 011-1h5"/>'),
    play: svg('<path d="M8 5v14l11-7z" fill="currentColor" stroke="none"/>')
  };

  var store = {
    get: function (key) {
      try { return window.sessionStorage.getItem(key); } catch (e) { return null; }
    },
    set: function (key, value) {
      try { window.sessionStorage.setItem(key, value); } catch (e) {}
    }
  };

  function noop() {}

  function readItem(el) {
    var script = el.querySelector('script[data-sv-json]');
    if (!script) return null;
    try { return JSON.parse(script.textContent); } catch (e) { return null; }
  }

  function readOptions(el) {
    return {
      afterAdd: el.getAttribute('data-after-add') || 'stay',
      atcLabel: el.getAttribute('data-atc-label') || 'Add to cart',
      atcBg: el.getAttribute('data-atc-bg') || '#15803d',
      atcColor: el.getAttribute('data-atc-color') || '#ffffff'
    };
  }

  function refreshCartCount(data) {
    var bubble = document.getElementById('cart-icon-bubble');
    var bubbleHtml = data && data.sections && data.sections['cart-icon-bubble'];
    if (bubble && bubbleHtml) {
      var doc = new DOMParser().parseFromString(bubbleHtml, 'text/html');
      var source = doc.querySelector('.shopify-section');
      if (source) {
        bubble.innerHTML = source.innerHTML;
        return;
      }
    }
    fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var nodes = document.querySelectorAll(
          '[data-cart-count], .cart-count, .js-cart-count, .cart-count-bubble > span[aria-hidden="true"]'
        );
        Array.prototype.forEach.call(nodes, function (node) {
          node.textContent = cart.item_count;
        });
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      })
      .catch(noop);
  }

  /* ------------------------------------------------------------------ */
  /* Full-screen player                                                  */
  /* ------------------------------------------------------------------ */

  var Player = {
    el: null,
    refs: null,
    items: [],
    index: 0,
    opts: {},
    muted: false,
    trigger: null,
    variant: null,
    busy: false,

    build: function () {
      var self = this;
      var el = document.createElement('div');
      el.className = 'sv-modal';
      el.hidden = true;
      el.setAttribute('role', 'dialog');
      el.setAttribute('aria-modal', 'true');
      el.setAttribute('aria-label', 'Product video');
      el.innerHTML = [
        '<div class="sv-modal__backdrop" data-sv-close></div>',
        '<button type="button" class="sv-modal__nav sv-modal__nav--prev" aria-label="Previous video">' + ICON.prev + '</button>',
        '<div class="sv-modal__stage">',
        '  <div class="sv-modal__progress"><span></span></div>',
        '  <video class="sv-modal__video" playsinline></video>',
        '  <div class="sv-modal__top">',
        '    <button type="button" class="sv-modal__icon sv-modal__mute" aria-label="Mute"></button>',
        '    <button type="button" class="sv-modal__icon sv-modal__close" aria-label="Close video">' + ICON.close + '</button>',
        '  </div>',
        '  <div class="sv-modal__side">',
        '    <button type="button" class="sv-modal__icon sv-modal__share" aria-label="Share">' + ICON.share + '</button>',
        '  </div>',
        '  <div class="sv-modal__product">',
        '    <a class="sv-modal__product-link">',
        '      <img class="sv-modal__thumb" alt="" width="56" height="70">',
        '      <span class="sv-modal__info">',
        '        <span class="sv-modal__title"></span>',
        '        <span class="sv-modal__prices">',
        '          <span class="sv-modal__price"></span>',
        '          <s class="sv-modal__compare"></s>',
        '          <span class="sv-modal__off"></span>',
        '        </span>',
        '      </span>',
        '      <span class="sv-modal__external">' + ICON.external + '</span>',
        '    </a>',
        '    <label class="sv-modal__variant" hidden>',
        '      <span class="sv-modal__variant-label">Select option</span>',
        '      <select class="sv-modal__select"></select>',
        '    </label>',
        '    <button type="button" class="sv-modal__atc"></button>',
        '    <p class="sv-modal__msg" role="status" aria-live="polite"></p>',
        '  </div>',
        '</div>',
        '<button type="button" class="sv-modal__nav sv-modal__nav--next" aria-label="Next video">' + ICON.next + '</button>'
      ].join('');
      document.body.appendChild(el);

      var q = function (selector) { return el.querySelector(selector); };
      this.el = el;
      this.refs = {
        video: q('.sv-modal__video'),
        bar: q('.sv-modal__progress span'),
        prev: q('.sv-modal__nav--prev'),
        next: q('.sv-modal__nav--next'),
        mute: q('.sv-modal__mute'),
        close: q('.sv-modal__close'),
        share: q('.sv-modal__share'),
        link: q('.sv-modal__product-link'),
        thumb: q('.sv-modal__thumb'),
        title: q('.sv-modal__title'),
        price: q('.sv-modal__price'),
        compare: q('.sv-modal__compare'),
        off: q('.sv-modal__off'),
        variantWrap: q('.sv-modal__variant'),
        select: q('.sv-modal__select'),
        atc: q('.sv-modal__atc'),
        msg: q('.sv-modal__msg')
      };
      var r = this.refs;

      q('[data-sv-close]').addEventListener('click', function () { self.close(); });
      r.close.addEventListener('click', function () { self.close(); });
      r.prev.addEventListener('click', function () { self.show(self.index - 1); });
      r.next.addEventListener('click', function () { self.show(self.index + 1); });
      r.mute.addEventListener('click', function () {
        self.muted = !self.muted;
        r.video.muted = self.muted;
        self.syncMute();
      });
      r.video.addEventListener('click', function () {
        if (r.video.paused) { r.video.play().catch(noop); } else { r.video.pause(); }
      });
      r.video.addEventListener('timeupdate', function () {
        if (r.video.duration) {
          r.bar.style.width = (r.video.currentTime / r.video.duration) * 100 + '%';
        }
      });
      r.video.addEventListener('ended', function () {
        if (self.items.length > 1) self.show(self.index + 1);
      });
      r.share.addEventListener('click', function () { self.share(); });
      r.select.addEventListener('change', function () {
        var item = self.items[self.index];
        var match = (item.variants || []).filter(function (v) {
          return String(v.id) === r.select.value;
        })[0];
        if (match) self.setVariant(match);
      });
      r.atc.addEventListener('click', function () { self.add(); });

      document.addEventListener('keydown', function (event) {
        if (!self.el || self.el.hidden) return;
        if (event.key === 'Escape') {
          self.close();
        } else if (event.key === 'ArrowLeft' && self.items.length > 1 && event.target !== r.select) {
          self.show(self.index - 1);
        } else if (event.key === 'ArrowRight' && self.items.length > 1 && event.target !== r.select) {
          self.show(self.index + 1);
        } else if (event.key === 'Tab') {
          var focusable = Array.prototype.filter.call(
            self.el.querySelectorAll('button, a[href], select'),
            function (node) { return !node.disabled && node.offsetParent !== null; }
          );
          if (!focusable.length) return;
          var first = focusable[0];
          var last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }
      });
    },

    open: function (items, index, opts, trigger) {
      if (!items || !items.length) return;
      if (!this.el) this.build();
      this.items = items;
      this.opts = opts || {};
      this.trigger = trigger || null;
      this.el.style.setProperty('--sv-atc-bg', this.opts.atcBg || '#15803d');
      this.el.style.setProperty('--sv-atc-color', this.opts.atcColor || '#ffffff');
      this.el.classList.toggle('sv-modal--single', items.length < 2);
      this.el.hidden = false;
      document.documentElement.classList.add('sv-lock');
      this.show(index || 0);
      this.refs.close.focus();
    },

    show: function (index) {
      var r = this.refs;
      var count = this.items.length;
      this.index = ((index % count) + count) % count;
      var item = this.items[this.index];

      r.bar.style.width = '0%';
      if (item.poster) { r.video.poster = item.poster; } else { r.video.removeAttribute('poster'); }
      r.video.loop = count < 2;
      r.video.src = item.video;
      this.play();

      r.link.href = item.url;
      r.link.setAttribute('aria-label', 'View product: ' + item.title);
      r.title.textContent = item.title;
      if (item.image) {
        r.thumb.src = item.image;
        r.thumb.hidden = false;
      } else {
        r.thumb.hidden = true;
      }

      var variants = item.variants || [];
      var initial = variants.filter(function (v) { return v.available; })[0] || variants[0] || null;
      r.select.innerHTML = '';
      if (!item.hasOnlyDefaultVariant && variants.length > 1) {
        variants.forEach(function (v) {
          var option = document.createElement('option');
          option.value = String(v.id);
          option.textContent = v.title + (v.available ? '' : ' - Sold out');
          option.disabled = !v.available;
          r.select.appendChild(option);
        });
        if (initial) r.select.value = String(initial.id);
        r.variantWrap.hidden = false;
      } else {
        r.variantWrap.hidden = true;
      }
      r.msg.textContent = '';
      this.setVariant(initial);
    },

    setVariant: function (variant) {
      var r = this.refs;
      this.variant = variant;
      if (!variant) {
        r.price.textContent = '';
        r.compare.textContent = '';
        r.off.textContent = '';
        r.atc.disabled = true;
        r.atc.textContent = 'Unavailable';
        return;
      }
      r.price.textContent = variant.price;
      r.compare.textContent = variant.compare || '';
      r.off.textContent = variant.compare && variant.off > 0 ? variant.off + '% OFF' : '';
      r.atc.disabled = !variant.available;
      r.atc.textContent = variant.available ? this.opts.atcLabel || 'Add to cart' : 'Sold out';
    },

    syncMute: function () {
      var r = this.refs;
      r.mute.innerHTML = this.muted ? ICON.soundOff : ICON.soundOn;
      r.mute.setAttribute('aria-label', this.muted ? 'Unmute' : 'Mute');
    },

    play: function () {
      var self = this;
      var video = this.refs.video;
      video.muted = this.muted;
      this.syncMute();
      var attempt = video.play();
      if (attempt && attempt.catch) {
        attempt.catch(function () {
          // Browser blocked playback with sound: fall back to muted.
          if (!video.muted) {
            self.muted = true;
            video.muted = true;
            self.syncMute();
            video.play().catch(noop);
          }
        });
      }
    },

    share: function () {
      var item = this.items[this.index];
      var msg = this.refs.msg;
      var url = new URL(item.url, window.location.origin).href;
      if (navigator.share) {
        navigator.share({ title: item.title, url: url }).catch(noop);
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () {
          msg.textContent = 'Link copied';
          setTimeout(function () { msg.textContent = ''; }, 2000);
        }).catch(noop);
      }
    },

    add: function () {
      var self = this;
      var r = this.refs;
      var variant = this.variant;
      if (!variant || !variant.available || this.busy) return;

      this.busy = true;
      r.atc.disabled = true;
      r.atc.textContent = 'Adding…';
      r.msg.textContent = '';

      var body = { id: variant.id, quantity: 1 };

      // Dawn-style themes expose a cart drawer / notification we can refresh.
      var themeCart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var canRender = !!(
        themeCart &&
        typeof themeCart.getSectionsToRender === 'function' &&
        typeof themeCart.renderContents === 'function'
      );
      if (canRender) {
        try {
          body.sections = themeCart.getSectionsToRender().map(function (section) { return section.id; });
          body.sections_url = window.location.pathname;
        } catch (e) {
          canRender = false;
        }
      }

      fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) {
              throw new Error(data.description || data.message || 'Could not add to cart');
            }
            return data;
          });
        })
        .then(function (data) {
          document.dispatchEvent(
            new CustomEvent('shoppable-video:added', { detail: { variantId: variant.id, response: data } })
          );

          var mode = self.opts.afterAdd || 'stay';
          if (mode === 'cart') {
            window.location.href = ROOT + 'cart';
            return;
          }
          if (mode === 'drawer') {
            if (canRender) {
              try {
                self.close();
                themeCart.classList.remove('is-empty');
                themeCart.renderContents(data);
                return;
              } catch (e) {}
            }
            window.location.href = ROOT + 'cart';
            return;
          }

          refreshCartCount(data);
          r.atc.textContent = 'Added ✓';
          setTimeout(function () {
            if (self.variant === variant) self.setVariant(variant);
          }, 1800);
        })
        .catch(function (error) {
          r.msg.textContent = error.message;
          self.setVariant(variant);
        })
        .then(function () {
          self.busy = false;
        });
    },

    close: function () {
      if (!this.el || this.el.hidden) return;
      var video = this.refs.video;
      video.pause();
      video.removeAttribute('src');
      video.load();
      this.el.hidden = true;
      document.documentElement.classList.remove('sv-lock');
      if (this.opts && typeof this.opts.onClose === 'function') this.opts.onClose();
      if (this.trigger && document.contains(this.trigger)) this.trigger.focus();
    }
  };

  /* ------------------------------------------------------------------ */
  /* Homepage carousel                                                   */
  /* ------------------------------------------------------------------ */

  function initSection(section) {
    if (section.__svReady) return;
    section.__svReady = true;

    var items = [];
    var autoplay = section.getAttribute('data-autoplay') === 'true' && !REDUCED;
    var cards = section.querySelectorAll('[data-sv-item]');

    Array.prototype.forEach.call(cards, function (card) {
      var item = readItem(card);
      var button = card.querySelector('[data-sv-open]');
      if (!item || !item.video || !button) return;
      var position = items.push(item) - 1;
      button.addEventListener('click', function () {
        Player.open(items, position, readOptions(section), button);
      });
    });

    // Lazy-load previews and only play the ones on screen.
    var videos = section.querySelectorAll('.sv-card__video');
    var load = function (video) {
      if (!video.getAttribute('src') && video.getAttribute('data-src')) {
        video.src = video.getAttribute('data-src');
      }
    };
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            if (autoplay) {
              load(video);
              var attempt = video.play();
              if (attempt && attempt.catch) attempt.catch(noop);
            }
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.4 });
      Array.prototype.forEach.call(videos, function (video) { observer.observe(video); });
    }

    var track = section.querySelector('[data-sv-track]');
    var prev = section.querySelector('[data-sv-prev]');
    var next = section.querySelector('[data-sv-next]');
    if (track && prev && next) {
      var scrollByPage = function (direction) {
        track.scrollBy({ left: direction * track.clientWidth * 0.8, behavior: REDUCED ? 'auto' : 'smooth' });
      };
      var syncArrows = function () {
        var max = track.scrollWidth - track.clientWidth - 2;
        prev.hidden = track.scrollLeft <= 2;
        next.hidden = track.scrollLeft >= max;
      };
      prev.addEventListener('click', function () { scrollByPage(-1); });
      next.addEventListener('click', function () { scrollByPage(1); });
      track.addEventListener('scroll', syncArrows, { passive: true });
      window.addEventListener('resize', syncArrows);
      syncArrows();
    }
  }

  /* ------------------------------------------------------------------ */
  /* Product-page floating video                                         */
  /* ------------------------------------------------------------------ */

  function mountFloat(el, item) {
    var handle = el.getAttribute('data-handle');
    el.insertAdjacentHTML(
      'beforeend',
      '<button type="button" class="sv-float__open" aria-label="Watch product video">' +
        '<video class="sv-float__video" muted loop playsinline preload="metadata"></video>' +
        '<span class="sv-float__play">' + ICON.play + '</span>' +
      '</button>' +
      '<button type="button" class="sv-float__close" aria-label="Hide product video">' + ICON.close + '</button>'
    );

    var video = el.querySelector('.sv-float__video');
    var openButton = el.querySelector('.sv-float__open');
    var closeButton = el.querySelector('.sv-float__close');
    var playPreview = function () {
      if (REDUCED) return;
      var attempt = video.play();
      if (attempt && attempt.catch) attempt.catch(noop);
    };

    if (item.poster) video.poster = item.poster;
    video.src = item.video;
    el.hidden = false;
    playPreview();

    openButton.addEventListener('click', function () {
      video.pause();
      var opts = readOptions(el);
      opts.onClose = playPreview;
      Player.open([item], 0, opts, openButton);
    });
    closeButton.addEventListener('click', function () {
      video.pause();
      el.hidden = true;
      store.set('sv-dismissed:' + handle, '1');
    });
  }

  function initFloat(el) {
    if (el.__svReady) return;
    el.__svReady = true;

    var item = readItem(el);
    if (!item) return;
    var handle = el.getAttribute('data-handle');
    if (!DESIGN && store.get('sv-dismissed:' + handle)) return;

    // 1. Video from the product metafield.
    if (item.video) {
      mountFloat(el, item);
      return;
    }

    // 2. Video tagged with this product in the homepage section.
    if (el.getAttribute('data-fallback') !== 'true') return;

    var key = 'sv-video:' + handle;
    var cached = null;
    try { cached = JSON.parse(store.get(key)); } catch (e) {}
    if (!DESIGN && cached && Date.now() - cached.t < FALLBACK_TTL) {
      if (cached.video) {
        item.video = cached.video;
        item.poster = cached.poster;
        mountFloat(el, item);
      }
      return;
    }

    fetch(el.getAttribute('data-fallback-url') || ROOT, { credentials: 'same-origin' })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nodes = doc.querySelectorAll('[data-sv-item]');
        var match = null;
        for (var i = 0; i < nodes.length; i++) {
          if (nodes[i].getAttribute('data-handle') === handle) {
            match = readItem(nodes[i]);
            break;
          }
        }
        var found = !!(match && match.video);
        store.set(key, JSON.stringify({
          t: Date.now(),
          video: found ? match.video : '',
          poster: found ? match.poster : ''
        }));
        if (found) {
          item.video = match.video;
          item.poster = match.poster;
          mountFloat(el, item);
        }
      })
      .catch(noop);
  }

  /* ------------------------------------------------------------------ */

  function init(scope) {
    var rootNode = scope || document;
    Array.prototype.forEach.call(rootNode.querySelectorAll('[data-sv-section]'), initSection);
    Array.prototype.forEach.call(rootNode.querySelectorAll('[data-sv-float]'), initFloat);
  }

  window.ShoppableVideo = { init: init, open: function (items, index, opts) { Player.open(items, index, opts); } };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
